import Image, { StaticImageData } from 'next/image'
import { HeroContainer, ImageWrapper } from './HeroImage.styles'

type HeroImageProps = {
    thumbnail: StaticImageData;
    alt: string;
}

export const HeroImage = ({thumbnail, alt}: HeroImageProps) => {
    
    return (
        <HeroContainer>
            <ImageWrapper>
                <Image priority={true} src={thumbnail} alt={alt} />
            </ImageWrapper>
        </HeroContainer> 
    )
}

